import { createAsyncThunk } from '@reduxjs/toolkit';
import { createMmWsAction, wsMmSend } from '@skynet/data-ws-mm';
import type { DeleteApiKeyPayload } from './types';
import { SubAccountCommands } from './types';

export interface ListenPayload {
  section: 'api-keys';
}

/** Asks for the main accounts (`MainAccounts`) and the `SupportedOperations` frame. */
export const listen = createMmWsAction<ListenPayload, ListenPayload>(
  'subAccounts/listen',
  (data) => ({
    command: 'Listen',
    ...data,
  }),
);

export interface ListenSubAccountsPayload extends ListenPayload {
  /** The main account whose sub-accounts are asked for. */
  mainAccountID: number;
}

/**
 * Asks for the sub-accounts of one main account (`SubAccounts`): the same
 * Listen, naming the main account.
 */
export const listenSubAccounts = createMmWsAction<
  ListenSubAccountsPayload,
  ListenSubAccountsPayload
>('subAccounts/listenSubAccounts', (data) => ({
  command: 'Listen',
  ...data,
}));

/** Deletes one API key of an account listed on the page; its progress is `resRemove`. */
export const deleteApiKey = createAsyncThunk(
  'subAccounts/deleteApiKey',
  (data: DeleteApiKeyPayload, thunkApi) =>
    thunkApi.dispatch(
      wsMmSend({
        command: SubAccountCommands.DeleteAPIKey,
        ...data,
      }),
    ),
);
